import { get, post } from '../../utils/request'


// 查询导航菜单
const headerMenuIe = get('/main/heaMenu/api/numberList')
export {
  headerMenuIe
}



// WEBPACK FOOTER //
// ./src/api/common/common.js